import React, { Fragment } from 'react'
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useSelector } from 'react-redux'

export default function MenuLateral({ familias, addFilter }) {
  const [open, setOpen] = React.useState(
    sessionStorage.getItem('open_menus') ? JSON.parse(sessionStorage.getItem('open_menus')) : [],
  )

  let styleVars = {}

  const loading = useSelector(state => state.listadoArticulos)

  const handleClick = codigoFamilia => {
    let newOpen

    setOpen(prevOpen => {
      if (codigoFamilia === 'Expanded') {
        newOpen = prevOpen.includes('Expanded') ? [] : ['Expanded']
      } else {
        const getChildren = codigoFamilia => {
          const directChildren = familias
            .filter(family => family.codigo_padre === codigoFamilia)
            .map(family => family.codigo_familia)

          return directChildren.flatMap(getChildren).concat(directChildren)
        }

        const itemsToRemove = [codigoFamilia, ...getChildren(codigoFamilia)]

        if (prevOpen.includes(codigoFamilia)) {
          newOpen = prevOpen.filter(item => !itemsToRemove.includes(item))
        } else {
          newOpen = [...prevOpen, codigoFamilia]
        }
      }
      sessionStorage.setItem('open_menus', JSON.stringify(newOpen))
      return newOpen
    })
  }

  const isMenuDisabled = () => {
    return Object.keys(loading).some(menu => menu?.isLoading === true)
  }

  const renderizarHijos = (codigo_padre, colorFamilia) => {
    return (
      <Collapse
        in={open.includes(codigo_padre)}
        timeout='auto'
        unmountOnExit>
        {familias.length > 0 &&
          familias.map((_, familia) => {
            if (familias[familia].codigo_padre === codigo_padre) {
              styleVars = {
                '--color-familia': colorFamilia || '#f4f4f4',
                "--border-size": colorFamilia ? '0.5em' : '0em',
              }
              return (
                <List
                  key={familias[familia].codigo_familia}
                  component='div'
                  disablePadding>
                  <ListItemButton
                    sx={{ pl: 2 * familias[familia].nivel }}
                    disabled={isMenuDisabled()}
                    style={{ ...styleVars }}
                    onClick={e => {
                      handleClick(familias[familia].codigo_familia)
                      addFilter(familias[familia])
                    }}>
                    <ListItemText secondary={familias[familia].descripcion} />
                  </ListItemButton>
                  {renderizarHijos(familias[familia].codigo_familia, colorFamilia)}
                </List>
              )
            }
          })}
      </Collapse>
    )
  }

  const renderMenuResponsive = () => {
    return (
      <div className='menu-lateral-mui'>
        <ListItemButton
          style={{
            position: 'fixed',
            width: '100%',
            zIndex: 100,
            backgroundColor: '#eeeeee',
            border: 'none',
          }}
          onClick={() => {
            handleClick('Expanded')
          }}>
          <ListItemIcon>
            {open.includes('Expanded') ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </ListItemIcon>
          <ListItemText
            key={'-1'}
            primary={'Menu familias'}
            className='texto-primer-nivel-responsive'
          />
        </ListItemButton>

        <Collapse
          in={open.includes('Expanded')}
          style={{ marginTop: '48px', maxHeight: '300px' }}>
          {familias.map((_, familia) => {
            if (!familias[familia].codigo_padre) {
              styleVars = {
                "--color-familia": familias[familia]?.reservado_alfa_1 || '#eeeeee',
                "--border-size": familias[familia]?.reservado_alfa_1 ? '0.5em' : '0em',
              }
            }
            return (
              <>
                {familias[familia].codigo_padre === null ||
                  familias[familia].codigo_padre === undefined ? (
                  <Fragment key={familias[familia].codigo_familia}>
                    <ListItemButton
                      style={{ ...styleVars }}
                      onClick={() => {
                        handleClick(familias[familia].codigo_familia)
                      }}>
                      <ListItemIcon>
                        {open.includes(familias[familia].codigo_familia) ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </ListItemIcon>
                      <ListItemText primary={familias[familia].descripcion} />
                    </ListItemButton>
                    {renderizarHijos(familias[familia].codigo_familia, familias[familia].reservado_alfa_1)}
                  </Fragment>
                ) : null}
              </>
            )
          })}
        </Collapse>
        <div></div>
      </div >
    )
  }

  const renderMenu = () => {
    return (
      <div className='menu-lateral-mui'>
        {familias.map((_, familia) => {
          if (!familias[familia].codigo_padre) {
            styleVars = {
              '--color-familia': familias[familia]?.reservado_alfa_1 || '#f4f4f4',
              "--border-size": familias[familia]?.reservado_alfa_1 ? '0.5em' : '0em',
            }
          }
          return (
            <>
              {familias[familia].codigo_padre === null ||
                familias[familia].codigo_padre === undefined ? (
                <Fragment key={familias[familia].codigo_familia}>
                  <ListItemButton
                    style={{ ...styleVars }}
                    onClick={() => {
                      handleClick(familias[familia].codigo_familia)
                    }}>
                    <ListItemIcon>
                      {open.includes(familias[familia].codigo_familia) ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </ListItemIcon>
                    <ListItemText primary={familias[familia].descripcion} />
                  </ListItemButton>
                  {renderizarHijos(familias[familia].codigo_familia, familias[familia].reservado_alfa_1)}
                </Fragment>
              ) : null}
            </>
          )
        })}
      </div>
    )
  }

  return (
    <>
      <div className='menu-lateral-collapsable'>{renderMenuResponsive()}</div>
      <div className='menu-lateral-desktop'>{renderMenu()}</div>
    </>
  )
}
